import styled from "styled-components";

import OutlinedButton from "./OutlinedButton.styled";

export const QuietButton = styled(OutlinedButton)`
  border: 1px solid transparent;

  &:hover {
    background-color: transparent;
    border: 1px solid transparent;
    color: ${(props) => props.theme.colors.highlight1};
  }

  &:disabled {
    background-color: transparent;
    color: ${(props) => props.theme.colors.disabled1};
    border: 1px solid transparent;
  }
`;
